import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store/reducers';

export interface HealthStatusState {
    isSystemOK: boolean;
}

const initialState: HealthStatusState = {
    isSystemOK: true,
};

export const healthStatusState = createSlice({
    name: 'healthStatus',
    initialState,
    reducers: {
        setSystemStatus: (state: HealthStatusState, action: PayloadAction<boolean>) => {
            state.isSystemOK = action.payload;
        },
    },
});

export const { setSystemStatus } = healthStatusState.actions;

export const getSystemStatus = (state: RootState) => state.healthStatus.isSystemOK;

export default healthStatusState.reducer;
